import { Box, styled, Typography } from '@mui/material';
import colors from 'src/utils/colors';

export const SectionTitle = styled(Typography)({
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: '20px',
  color: colors.darkBlue,
  marginBottom: '16px'
});

export const DetailsRow = styled(Box)({
  display: 'flex',
  gap: '56px',
  alignItems: 'center'
});

export const InlineIconText = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px'
});

export const FieldGroup = styled(Box)<{ width?: string }>(({ width }) => ({
  width: width ?? 'auto'
}));

export const FieldLabel = styled(Typography)(() => ({
  fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
  fontSize: '12px',
  fontWeight: 500,
  lineHeight: '18px',
  color: colors.grey,
  letterSpacing: '0.08px',
  marginBottom: '4px'
}));

export const StatusLabel = styled(FieldLabel)({});

export const FieldValue = styled(Typography)({
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: '24px',
  color: colors.darkBlue,
  overflow: 'hidden',
  display: '-webkit-box',
  WebkitLineClamp: 1,
  WebkitBoxOrient: 'vertical',
  textOverflow: 'ellipsis'
});

export const StatusGroup = styled(Box)({
  marginLeft: 'auto',
  marginRight: '118px'
});


